import {
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogContent,
  DialogBody,
  Button,
  Image,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionPanel,
  FluentProvider,
} from "@fluentui/react-components";
import * as React from "react";
import { useContext, useEffect } from "react";
import { TCTeamsFxContext } from "./TCTeamsContext";
import { TeamsFxContext } from "./Context";
import { logger } from "../Logger";

const TeamcenterError: React.FunctionComponent = () => {
  const teamsContext = useContext(TeamsFxContext);
  const tcTeamsContext = useContext(TCTeamsFxContext);
  const [open, setOpen] = React.useState(false);

  if (!tcTeamsContext) {
    throw new Error("TC Teams context not defined.");
  }

  const failureError = tcTeamsContext.failure?.error;

  useEffect(() => {
    if (
      failureError &&
      failureError.statusCode !== 401 &&
      (failureError.statusCode !== 403 ||
        (failureError.statusCode === 403 &&
          failureError.message === tcTeamsContext.i18n.LicenseErrorMessage))
    ) {
      setOpen(!!failureError);
    }
  }, [failureError, tcTeamsContext.i18n.LicenseErrorMessage]);

  if (failureError) {
    logger.logError(JSON.stringify(failureError.message));
  }

  return (
    <FluentProvider theme={teamsContext?.theme}>
      <Dialog
        modalType="non-modal"
        open={open}
        onOpenChange={(_event, data) => setOpen(data.open)}
      >
        <DialogSurface className="login-dialog-surface button">
          <DialogBody>
            <DialogTitle className="text-center">
              <span>{tcTeamsContext.i18n.IssueText}</span>
            </DialogTitle>
            <DialogContent>
              <div className="text-center">
                <div>
                  <Image src="error.png" className="image-width" />
                </div>
                <div>{tcTeamsContext.i18n.ReloadText}</div>
                <div>
                  {" "}
                  {tcTeamsContext.i18n.ReachOutText}:{" "}
                  {failureError?.correlationId}{" "}
                </div>
                <br />
                {failureError &&
                  failureError.statusCode &&
                  failureError.statusCode === 403 && (
                    <div>
                      <b>{tcTeamsContext.i18n.TcTeamsText}</b>
                      {tcTeamsContext.i18n.NotOnBoardedText}
                    </div>
                  )}
                <br />
                <div className="error-buttons-container">
                  <Button
                    className="button-margin-right"
                    onClick={() => setOpen(false)}
                  >
                    Close
                  </Button>
                  <Button
                    className="button-margin-right"
                    onClick={() => {
                      window.location.reload();
                    }}
                  >
                    {tcTeamsContext.i18n.ReloadAppText}
                  </Button>
                </div>
              </div>
              {failureError && (
                <Accordion collapsible>
                  <AccordionItem value="1">
                    <AccordionHeader>
                      {tcTeamsContext.i18n.ErrorDetailsText}:
                    </AccordionHeader>
                    <AccordionPanel>
                      {tcTeamsContext.i18n.CorrelationIDText}:{" "}
                      {failureError.correlationId}
                    </AccordionPanel>
                    <AccordionPanel>
                      {tcTeamsContext.i18n.ErrorCodeText}:{" "}
                      {failureError.statusCode}
                    </AccordionPanel>
                    <AccordionPanel>
                      {tcTeamsContext.i18n.ErrorMessageText}:{" "}
                      {failureError.message}
                    </AccordionPanel>
                  </AccordionItem>
                </Accordion>
              )}
            </DialogContent>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </FluentProvider>
  );
};

export default TeamcenterError;
